module.exports = __webpack_public_path__ + "static/media/icon-face.db09a232.svg";